import { ComponentProps } from 'react';

const BordProductLoading = (props: ComponentProps<'svg'>) => {
  const { fill, stroke, width, height } = props;

  return (
    <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_23631_17201)">
        <path d="M2.25 5.1321V2.99945H9.75V5.1321C9.75 6.71949 9.75 7.51318 9.26185 8.00631C8.77369 8.49945 7.98802 8.49945 6.41667 8.49945H5.58333C4.01199 8.49945 3.22631 8.49945 2.73816 8.00631C2.25 7.51318 2.25 6.71949 2.25 5.1321Z" fill={fill || 'white'} stroke={stroke || '#999999'} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M2.25 2.99968L2.61058 2.23045C2.89022 1.63387 3.03005 1.33558 3.31346 1.16763C3.59688 0.99968 3.96042 0.99968 4.6875 0.99968H7.3125C8.03958 0.99968 8.40312 0.99968 8.68654 1.16763C8.96995 1.33558 9.10978 1.63387 9.38942 2.23045L9.75 2.99968" stroke={stroke || '#999999'} strokeLinecap="round" />
        <path d="M5.25 4.49945H6.75" stroke={stroke || '#999999'} strokeLinecap="round" />
        <path d="M6 9.74945V10.9995M6 9.74945L3.5 9.74945M6 9.74945H8.5M3.5 9.74945H2.25C1.55964 9.74945 0.999999 10.3091 0.999999 10.9995M3.5 9.74945V10.9995M8.5 9.74945H9.75C10.4404 9.74945 11 10.3091 11 10.9995M8.5 9.74945V10.9995" stroke={stroke || '#999999'} strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_23631_17201">
          <rect width={width || 12} height={height || 12} fill={fill || 'white'} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default BordProductLoading;
